import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { SafeHTMLPipeStandAlone } from 'src/app/misc/pipes/safe-html-standalone.pipe';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipeStandAlone } from 'src/app/services/translator.pipe.standalone';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    ToastModule,
    MessagesModule,
    FormsModule,
    ButtonModule,
    RadioButtonModule,
    DropdownModule,
    CheckboxModule,
    RatingModule,
    TranslatorPipeStandAlone,
    TableModule,
    CalendarModule,
    ProgressBarModule,
    ConfirmDialogModule,
    SafeHTMLPipeStandAlone,
  ],
  selector: 'app-question-template-standalone',
  templateUrl: './question-template-standalone.component.html',
  styleUrls: ['./question-template-standalone.component.scss'],
})
export class QuestionTemplateComponentStandAlone {
  @ViewChild('questionDiv') questionDiv?: ElementRef;

  //Current Question
  @Input() question: any;
  @Input() disabled: boolean = false;
  @Input() isAssessment: boolean = false;
  @Output() conditionalQuestions: EventEmitter<any> = new EventEmitter<any>();

  //To access static attets from server
  staticFileUrl: string = GlobalConstants.staticFilesURL;

  //Date selection dropdown options
  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  years: number[] = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  //Dragged question in drag and drop question type
  draggedQuestion: any;

  dragStart(product: any) {
    this.draggedQuestion = product;
  }

  drop(question: any) {
    if (this.draggedQuestion) {
      question.meta.orderedFields = [
        ...question.meta.orderedFields,
        this.draggedQuestion,
      ];
      question.meta.fields = question.meta.fields.filter(
        (val: any) => val.label != this.draggedQuestion.label
      );
      this.draggedQuestion = null;
    }
  }

  dragEnd() {
    this.draggedQuestion = null;
  }

  addOrRemoveImageFromList(question: any, label: string) {
    if (question.meta.value.includes(label)) {
      let index = question.meta.value.indexOf(label);
      question.meta.value.splice(index, 1);
    } else {
      question.meta.value.push(label);
    }
    this.checkConditionalQuestion();
  }

  checkConditionalQuestion() {
    this.conditionalQuestions.emit();
  }

  getRankDDValues(field: any, value: any, meta: any) {
    let values: any[] = [];

    meta.fields.forEach((metaField: any, i: number) => {
      if (field.label == metaField.label) {
        metaField.value = value;
      }
      values.push({
        label: (i + 1).toString(),
        value: i + 1,
        disabled: metaField.value == i + 1,
      });
    });

    meta.options = [
      { label: '-Select-', value: -1, disabled: false },
      ...values,
    ];
    meta.options = this.isAssessment
      ? values
      : [{ label: '-Select-', value: -1, disabled: false }, ...values];
  }

  getRankDDValues2(question: any): string[] {
    let values: string[] = [];

    for (let i = 1; i < question.meta.fields.length + 1; i++) {
      values.push(i.toString());
    }

    return values;
  }

  addRemoveValueInFieldArray(field: any, value: any) {
    if (field.value.includes(value)) {
      field.value = field.value.filter((v: string) => v != value);
      return;
    }
    field.value = [...field.value, value];
  }

  handleClick(question: any, field: any): void {
    if (!this.disabled) {
      question.meta.value = field.label;
      this.checkConditionalQuestion();
    }
  }

  getDatePlaceholder(date: string) {
    if (date) {
      return date.split('T')[0];
    }
    return '';
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode !== 46 &&
        charCode !== 45 &&
        charCode > 31 &&
        (charCode < 48 || charCode > 57)) ||
      (event.target.value.includes('.') && charCode === 46)
    ) {
      return false;
    }
    return true;
  }
}
